import { Button, Drawer, Form, Input, Row, Select, notification } from 'antd'
import './DrawerConclusion.style.less'
import { DoubleRightOutlined, EditOutlined } from '@ant-design/icons'
import { INSPECTION_SECTION_RESULT } from '@/constant/status'
import { useEffect, useState } from 'react'
import { useMutation } from 'react-query'
import { useParams } from 'react-router-dom'
import { queryClient } from '@/config/react-query'
import { saveInspectionResultRef } from '../../InSpectionReport.service'
import { useOverallResultSettingHook } from '@/screens/QSF/Inspection/Inspection.hook'

interface Props {
  onClose: () => void
  open: boolean
  data: any
  dataInspection?: any
  index: number
}

function DrawerConclusion(props: Props) {
  const onFinish = () => {}

  const { RESULT_ARRAY, RESULT_OBJECT } = INSPECTION_SECTION_RESULT

  const [form] = Form.useForm()

  const result = Form.useWatch('result', form)

  const params = useParams()
  const [isChange, setisChange] = useState(false)
  const [mouseOver, setMouseOver] = useState(false)

  useEffect(() => {
    if (!props.open) {
      setisChange(false)
    }
  }, [props.open])

  useEffect(() => {
    if (props.open) {
      form.setFieldsValue({
        ...(props.data?.result && { result: props.data?.result }),
        comment: props.data?.comment,
      })
    } else {
      form.resetFields()
    }
  }, [props.open])

  useEffect(() => {
    const isOpenSelect = document.querySelector('.ant-select-open')
    const allowScrolling = !mouseOver && !isOpenSelect
    if (allowScrolling) {
      document.body.style.overflow = 'auto'
    } else {
      document.body.style.overflow = ''
    }
  }, [mouseOver])

  const onSave: any = useMutation(async () => {
    await form.validateFields()
    const value = form.getFieldsValue()
    await saveInspectionResultRef(
      params?.key,
      value?.result ?? '',
      value?.comment
    )
    await queryClient.invalidateQueries(['GET_REPORT_DATA_HEADER'])
    await queryClient.invalidateQueries(['GET_REPORT_DATA'])
    props.onClose()
  })

  useEffect(() => {
    if (onSave.isError) {
      notification.error({
        message: onSave.error?.response?.data?.message,
        duration: 3,
        placement: 'top',
      })
    }
  }, [onSave.isError])

  const { data: overallResultSettingData } = useOverallResultSettingHook()

  const overallResults = (overallResultSettingData as any)?.options || []

  const templateOverallResult =
    props.dataInspection?.template?.option?.overall_result

  const type = templateOverallResult?.type || 'default'

  const customOptions = templateOverallResult?.custom?.options || []
  let filteredOptions: any[] = []

  if (type === 'custom' && customOptions.length > 0) {
    filteredOptions = customOptions.map((customOpt: any) => {
      const fromSystem = overallResults.find(
        (sysOpt: any) => sysOpt.name === customOpt.name
      )
      return fromSystem || customOpt
    })
  } else {
    filteredOptions = overallResults.filter((option: any) => option.selected)
  }
  const color = (result) => {
    const lowerResult = (result ?? '').toLowerCase()

    const sysOption = overallResults.find(
      (opt) =>
        opt.name?.toLowerCase() === lowerResult ||
        opt.value?.toLowerCase() === lowerResult
    )
    if (sysOption) {
      return sysOption.color
    }

    const customOptions = templateOverallResult?.custom?.options || []
    const tplOption = customOptions.find(
      (opt) =>
        opt.name?.toLowerCase() === lowerResult ||
        opt.value?.toLowerCase() === lowerResult
    )
    if (tplOption) return tplOption.color

    const upperResult = (result ?? '').toUpperCase()
    return upperResult == RESULT_OBJECT.PASS
      ? '#65bf73'
      : upperResult == RESULT_OBJECT.FAIL
      ? '#C03261'
      : upperResult == RESULT_OBJECT.PENDING || upperResult == RESULT_OBJECT.CIO
      ? '#EF9747'
      : '#848484'
  }

  return (
    <Drawer
      title=""
      placement={'right'}
      closable={false}
      open={props.open}
      key={'right'}
      width={400}
      onMouseOver={() => {
        setMouseOver(true)
      }}
      onMouseLeave={() => setMouseOver(false)}
    >
      <div className="drawer-conclusion-container">
        <Button
          onClick={props.onClose}
          className="button-close"
          icon={<DoubleRightOutlined className="close-icon" />}
        />
        <Row align={'middle'} className="title-container">
          <EditOutlined /> <p>Edit Conclusion</p>
        </Row>
        <p className="section-name">Inspection Conclusion</p>
        <Form
          form={form}
          onFinish={onFinish}
          onChange={() => {
            setisChange(true)
          }}
          autoComplete="off"
          layout="vertical"
        >
          <Form.Item name={'result'} label="Overall Result">
            <Select
              allowClear
              onChange={() => {
                setisChange(true)
              }}
              placeholder="Overall Result"
              style={{
                color: color(result),
              }}
            >
              {filteredOptions.map((item) => {
                return (
                  <Select.Option
                    style={{
                      color: item.color,
                    }}
                    key={item.value}
                    value={item.value}
                  >
                    {item.value?.toUpperCase()}
                  </Select.Option>
                )
              })}
            </Select>
          </Form.Item>
          <Form.Item name={'comment'} label="Overall Comment">
            <Input.TextArea
              autoSize
              size="large"
              placeholder="Overall Comment"
            />
          </Form.Item>
        </Form>

        <Row className="button-container">
          <Button
            disabled={onSave.isLoading}
            onClick={props.onClose}
            className="cancel"
            size="large"
          >
            Cancel
          </Button>
          <Button
            onClick={() => onSave.mutate()}
            size="large"
            type="primary"
            disabled={onSave.isLoading || !isChange}
            loading={onSave.isLoading}
          >
            Save
          </Button>
        </Row>
      </div>
    </Drawer>
  )
}

export default DrawerConclusion
